import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/userPlaylist/importer/userPlaylistImporterActions'

export default importerReducers(actions)
